import React, { Component } from 'react';
import { Header, Button } from 'semantic-ui-react';
import Papa from 'papaparse';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import styled from 'styled-components';

const mutationMutlipleInsertNewsletters = (emails) => {
  let mutation = '';
  emails.forEach((email, index) => {
    mutation += `
      addNewsletterSubscriber${
        index + 1
      }: addNewsletterSubscriber(input: { email: "${email}" }) {
        id
        email
      }
    `;
  });

  const gqlMutation = gql`
  mutation deleteNewsletterSubscriber {
    ${mutation}
  }
 `;
  return gqlMutation;
};

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  margin: 0 15px 0 10px;
  color: ${(props) => props.color};
`;

class UploadNewsletterCSV extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileUploaded: null,
      mutationLoading: false,
      mutationSuccess: false,
      mutationError: false,
    };

    this.onUpload = this.onUpload.bind(this);
  }

  onUpload(event) {
    this.setState({ fileUploaded: event.target.files[0] });
  }

  onValidate() {
    const { fileUploaded } = this.state;
    const _this = this;
    Papa.parse(fileUploaded, {
      complete: (result) => {
        result.data.shift();
        _this.mutateNewSubscribers(result);
      },
    });
  }

  mutateNewSubscribers(csv) {
    this.setState({ mutationLoading: true });
    const emails = csv.data.map((csv) => {
      return csv.shift();
    });
    this.props.client
      .mutate({
        mutation: mutationMutlipleInsertNewsletters(emails),
        context: {
          headers: {
            'Accept-Language': 'fr',
            'User-Agent': 'GHD',
          },
        },
      })
      .then(({ data }) => {
        this.setState({
          mutationLoading: false,
          mutationSuccess: true,
          fileUploaded: null,
        });

        setTimeout(() => {
          this.setState({ mutationSuccess: false });
        }, 5000);
      })
      .catch(({ err }) => {
        this.setState({ mutationError: true, fileUploaded: null });
      });
  }

  render() {
    const { fileUploaded, mutationLoading, mutationError, mutationSuccess } =
      this.state;
    return (
      <div>
        <Header as="h5">Importer un fichier de contacts .csv</Header>
        <Row>
          <div>
            <Button
              as="label"
              htmlFor="file"
              type="button"
              content="Choisir un fichier"
              icon="upload"
              labelPosition="left"
            />
            <input
              type="file"
              id="file"
              accept=".csv"
              hidden
              onChange={this.onUpload}
            />
          </div>
          {fileUploaded && (
            <React.Fragment>
              <Text>{fileUploaded.name}</Text>
              <Button
                loading={mutationLoading}
                content="Valider"
                onClick={() => this.onValidate()}
                color="green"
              />
            </React.Fragment>
          )}
          {mutationSuccess && (
            <Text color="green">Adresses emails insérées avec succès</Text>
          )}
          {mutationError && <Text color="red">Une erreur est survenue</Text>}
        </Row>
      </div>
    );
  }
}

export default withApollo(UploadNewsletterCSV);



// WEBPACK FOOTER //
// ./src/components/UploadNewsletterCSV.js